<!--导入品名-->
<template>
    <div class="content-panel">
        <el-row :gutter="10" type="flex" justify="space-between" align="middle" class="breadcrumb-wrap">
            <el-col :span="20">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">{{msg('首页')}}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/admin/stock'}">{{msg('采购链接')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{msg('导入品名')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row :gutter="10"  class="ctrl-wrap">
            <el-col :sm="24" :md="12">
                <el-button size="mini"
                    @click="doSelectFile()" type="success" 
                    style="margin-right:5px; margin-bottom:5px;">
                        <i class="iconfont icon-xuanzewenjian" 
                            style="display:inline-block;margin-right:4px;"></i>
                        <transition name="el-fade-in-linear">
                            <span v-show="!isMinScreen">{{msg('上传文件')}}</span>
                        </transition>
                </el-button>
              
                <div ref="fileArea" style="display:none;">
                </div>
            </el-col>  
            <el-col :sm="24" :md="12">
                <el-button size="mini"
                    @click="doDownloadTpl()" type="primary" 
                    style="margin-right:5px; margin-bottom:5px;">
                        <i class="el-icon-download" style="display:inline-block;margin-right:4px;"></i>
                        <transition name="el-fade-in-linear">
                            <span v-show="!isMinScreen">{{msg('下载模板')}}</span>
                        </transition>
                </el-button>
            </el-col>  
        </el-row>
        <el-row :gutter="15">
            <el-table :data="results" :height="docHeight" style="width: 100%" size="mini" ref="dataTable" stripe>
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="xiapiTitle" :label="msg('产品标题')" min-width="200" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="productName" :label="msg('申报品名')" min-width="200" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="msg" :label="msg('上传结果')" min-width="220" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
import XLSX from "xlsx";
export default {
    name: 'PurchaseImportName',
    components: {},
    data(){
        return {
            excelHeads: [],
            excelData: null,
            results:[],
        }
    },
    computed: {
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
    },
    mounted(){
        this.results = [];
        this.excelData = [];
    },
    methods:{
        doSelectFile(){
            this.$refs.fileArea.innerHTML = "";
            var input = document.createElement("input");
            input.type="file";
            input.onchange=this.getUploadFile;    
            this.$refs.fileArea.appendChild(input);
            input.click();
        },
        getUploadFile(e) {
            this.excelData = null
            let fileName = e.target.files[0];
            let reader = new FileReader();
            reader.readAsBinaryString(fileName)
            reader.onload = (e) => {
                let workbook = XLSX.read(e.target.result, {type: 'binary'})
                let worksheet = workbook.Sheets[workbook.SheetNames[0]];
                let json = XLSX.utils.sheet_to_json(worksheet, {header:1})

                var heads = json[0];
                this.excelData = json.splice(1);
                this.excelHeads = heads;
                this.$refs.fileArea.innerHTML = "";
                this.doUpload();
            };
        },
        doDownloadTpl(){
            var titles = [
                ['产品标题','申报品名'], 
            ];
            var filename = '导入品名模板.xlsx';
            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(titles);
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, filename);
        },
        doUpload(){
            this.$axios.post(this.$kit.api.purchase.importName, this.excelData)
                .then((result) => {
                    if(result.status){
                        this.$message(result.msg);
                        this.results = result.data;
                    }else{
                        this.$message(result.msg);
                    }
                });
        },
    }
}
</script>
<style lang="scss" scoped>

</style>

